import base from './base';
import installApp from './installApp';
import links from './links';
import video from './video';

export default {
    video,
    installApp,
    links,
    base,
};
